module.exports = __webpack_public_path__ + "img/right.4d799cd7.svg";